import { Component, Input} from '@angular/core';

@Component({
    selector: 'finder-button',
    templateUrl: './finder-button.component.html',
    styleUrls: ['./finder-button.component.scss']
})
export class FinderButtonComponent {
    @Input() disabled: boolean;
    @Input() href: string;
    @Input() linkId: string;
    @Input() theme: string;
    @Input() fitText: boolean;
    @Input() selected: boolean;
    @Input() fullWidth: boolean;
    @Input() externalLink: boolean;
    @Input() anchor = false;
    @Input() ariaLabel: string;
    @Input() title: string;
    @Input() target = '_self';
    @Input() analyticsTracking = true;

    constructor() { }
}
